<div [class.proposal-row-removed]="removed" class="flex flex-row items-center gap-2">
  <div [class.pointer-events-none]="removed" class="flex-1 min-w-0">
    <ng-content></ng-content>
  </div>
  @if (reserveSpace || pending || removed) {
    <div class="w-[80px] shrink-0 flex flex-row">
      @if (pending || removed) {
        <app-proposal-actions (acceptClicked)="acceptClicked.emit()"
                              (rejectClicked)="rejectClicked.emit()"
                              [acceptLabel]="removed ? 'Löschen übernehmen' : 'Änderung übernehmen'"
                              [rejectLabel]="removed ? 'Behalten' : 'Änderung verwerfen'"></app-proposal-actions>
      }
    </div>
  }
</div>
